import { EditableQuestion, QuestionPhase } from '../../../types';

const phaseOf = (question: EditableQuestion): QuestionPhase => question.phase ?? 'pre_order';

const isPostOrder = (question: EditableQuestion) => phaseOf(question) === 'post_order';

const isInformationScreen = (question: EditableQuestion) => question.answer_selection === 'hidden';

export const findPhaseViolation = (questions: EditableQuestion[], blockingAnswers: string[]): string | null => {
  const questionsById = new Map(questions.map(question => [question._id, question]));

  for (const question of questions) {
    if (isPostOrder(question) && question.answers?.some(answer => blockingAnswers.includes(answer._id))) {
      return `"${question.question}" is asked after ordering, so it cannot have blocking answers`;
    }

    const parent = question.parent_question_id ? questionsById.get(question.parent_question_id) : undefined;
    if (!parent) continue;

    if (isInformationScreen(question) && phaseOf(question) !== phaseOf(parent)) {
      return `Information screen "${question.question}" must be asked at the same time as "${parent.question}"`;
    }

    if (!isPostOrder(question) && isPostOrder(parent)) {
      return `"${question.question}" is asked before ordering, so it cannot follow up "${parent.question}", which is asked after ordering`;
    }
  }

  return null;
};
